import React from "react";
import { cn } from "../../../design-system/index.js";
import { Button, Card } from "../../../design-system/index.js";
import { User, Users } from "lucide-react";

export default function AuthOptionsPage() {
  return (
    <div className="min-h-screen flex items-center justify-center py-16">
      <div className="w-full max-w-4xl">
        <div className="text-center mb-10">
          <h1 className={cn(
            "font-heading text-4xl font-bold",
            "text-[var(--color-warm-900)] mb-3"
          )}>
            Como você quer usar o Tesourinhos?
          </h1>
          <p className="text-lg text-[var(--color-warm-600)] max-w-2xl mx-auto">
            Escolha o tipo de conta que melhor se adapta às suas necessidades
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="p-6 text-center hover:shadow-lg transition-shadow">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[var(--color-rose-400)/15] mb-4">
              <User className="w-8 h-8 text-[var(--color-rose-400)]" />
            </div>
            <h3 className="text-xl font-bold text-[var(--color-warm-900)] mb-2">
              Família
            </h3>
            <p className="text-sm text-[var(--color-warm-500)] mb-4">
              Encontre babás verificadas para cuidar dos seus tesourinhos
            </p>
            <Button variant="default" className="w-full" asChild>
              <a href="/profile-selection?type=family">
                Continuar como Família
              </a>
            </Button>
          </Card>
          
          <Card className="p-6 text-center hover:shadow-lg transition-shadow">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[var(--color-slate-blue-400)/15] mb-4">
              <Users className="w-8 h-8 text-[var(--color-slate-blue-400)]" />
            </div>
            <h3 className="text-xl font-bold text-[var(--color-warm-900)] mb-2">
              Babá
            </h3>
            <p className="text-sm text-[var(--color-warm-500)] mb-4">
              Ofereça seus serviços e conecte-se com famílias
            </p>
            <Button variant="outline" className="w-full" asChild>
              <a href="/profile-selection?type=babysitter">
                Continuar como Babá
              </a>
            </Button>
          </Card>
          
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-[var(--color-warm-500)]">
            Já tem uma conta?{" "}
            <a href="/login" className="font-semibold text-[var(--color-rose-400)] hover:underline">
              Faça login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}